import * as PlayerActionTypes from './action-types.constants';
import * as CommentsDrawerActionTypes from '../drawers/comments/action-types.constants';
import * as TranscriptsDrawerActionTypes from '../drawers/transcripts/action-types.constants';
import * as WebViewActions from '@medscape-promo/medscapetv/web-view/web-view.actions';
import createPlayer from './middlewares/create-player';
import { VIEW_VIDEO_PLAYER_TRACKING } from '@medscape-promo/medscapetv/omniture-tracking';
const { mmodule, mlink } = VIEW_VIDEO_PLAYER_TRACKING;


// PlayerMiddleware is added to the media-player.store
const PlayerMiddleware = (storeAPI) => {
    let player = null;
    let wasPlayerPlaying = false;
    let isModuleViewTracked = false;
    return next => action => {
        // Do something in here, when each action is dispatched
        //const state = storeAPI.getState();
        //console.log('[PlayerMiddleware] current state', state)
        //console.log('[PlayerMiddleware] dispatching', action)
        let result = next(action);
        const nextState = storeAPI.getState();
        //console.log('[PlayerMiddleware] next state', nextState);

        switch (action.type) {
            case PlayerActionTypes.CREATE_PLAYER:
                createPlayer(storeAPI, action.media, action.containerEl)
                break;
            case PlayerActionTypes.PLAYER_CREATED:
                player = action.player;
                if (isModuleViewTracked === false) {
                    isModuleViewTracked = true;
                    storeAPI.dispatch(WebViewActions.omnitureTracking(`${mmodule}_${mlink["video-player"]}`));
                }
                break;
            case PlayerActionTypes.SET_MEDIA:
                if (player != null) {
                    player.setMedia(action.media);
                }

                break;
            case PlayerActionTypes.PLAYER_EVENT_PLAYING:
                if (nextState.CommentsDrawer.open === true || nextState.TranscriptsDrawer.open === true) {
                    wasPlayerPlaying = true;
                    player.amp.pause();
                }
                break;
            case PlayerActionTypes.DESTROY_PLAYER:
                //console.log('[PlayerMiddleware] Destroying Player:', player)
                if (player != null) {
                    player.destroy();
                    player = null;
                }
                break;
            case TranscriptsDrawerActionTypes.OPEN:
            case CommentsDrawerActionTypes.OPEN:
                (() => {
                    const { ENDED, PAUSED } = window.akamai.amp.PlayState;
                    wasPlayerPlaying = player.amp.playState !== PAUSED && player.amp.playState !== ENDED;
                    if (wasPlayerPlaying === true) {
                        player.amp.pause();
                    }
                })();
                break;
            case TranscriptsDrawerActionTypes.CLOSE:
            case CommentsDrawerActionTypes.CLOSE:
                if (wasPlayerPlaying === true) {
                    player.amp.play();
                }
                break;
        }
        return result
    }



}

export default PlayerMiddleware;